<div class="text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">Detach VDI Node</h4>
    <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onClose()" title="Close"></i>
  </div>

  <div class="modal-body">
    <p>Select deployment for the workstation to detach</p>
    <!--<form spellcheck="false" autocomplete="off" [formGroup]="addNodeForm" (ngSubmit)="onSubmit(addNodeForm)">-->
    <form>
      <div class="encloser">
        <div *ngFor="let node of selectedVMs" class="x">
          <mat-label style="width: 48%; font-size:15px">{{node.wsName}}</mat-label>
          <mat-form-field class="temp1" appearance="fill" style="width: 48%; margin-left: 2%; font-size: 12px;">
            <mat-label>Select Deployment</mat-label>
            <!--<mat-select formControlName="addUserDeployment" multiple>-->
            <mat-select (selectionChange)="addWorkStationObject($event, node.wsName)" multiple>
              <mat-option [value]="dep" *ngFor="let dep of node.deploymentName.split(',')">{{dep}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </form>
</div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onClose()">Close</button>
    <button type="button" class="btn btn-primary" (click)="onSubmit()">
      Submit
    </button>
  </div>
</div>
<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="default"
             zIndex="1"
             color="var(--s-primary-color)"
             type="ball-spin"
             [fullScreen]="false"><p class="pleaseWait">Please wait ...</p></ngx-spinner>
